module.exports = __webpack_public_path__ + "img/award-11.da1c039.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/awards/award-11.jpg
// module id = 1220
// module chunks = 1